exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container[data-v-c08c74ec] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  display: grid;\n  height: 120px;\n  -webkit-box-pack: left;\n      -ms-flex-pack: left;\n          justify-content: left;\n  width: 70%;\n  margin-left: 0px;\n  margin-bottom: 10px;\n}\n.titulo[data-v-c08c74ec] {\n  font-size: 22pt;\n  font-family: 'Asap';\n  font-weight: bold;\n  color: #606060;\n}\n.texto[data-v-c08c74ec] {\n  font-family: 'Asap';\n  font-size: 12pt;\n  width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: pre-wrap;\n  color: #606060;\n}\n", ""]);

// exports
